import { HasIdDisplay } from "~/@shared/api-types/id-name-display"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"
import { RecruitmentStatus } from "~/api/_common/types-for-recruitment"

const PATH = "/new-grad-jobs/limited"

type GetNewGradJobsLimitedQuery = {
  count?: number
}
type GetNewGradJobsLimited = {
  data: NewGradJobsLimited[]
}

export const fetchGetNewGradJobsLimited = defineFetcher(
  (query: GetNewGradJobsLimitedQuery): Promise<GetNewGradJobsLimited> => {
    return GET(PATH, query)
  }
)

interface NewGradJobsLimited {
  id: number
  title: string
  job_type: null | string
  assignment: null | string
  assumed_annual_income: number | null
  status: RecruitmentStatus
  url: string
  company: Company
  image: Image
  prefecture: HasIdDisplay | null
}

interface Company {
  id: number
  display: string
  main_img_url: string
  company_overview: string
}

interface Image {
  img_url: string
}
